import CloseIconButton from "@entrilia/shared/components/CloseIconButton";
import type { ListItemData } from "@entrilia/shared/components/inputs/CheckItemsList";
import { CompanySingleReportListItem } from "./CompanySingleReportListItem";
import { Failed } from "./controls/Failed";
import { ReportInProgress } from "./controls/ReportInProgress";
import ReportIsNotValid from "./controls/ReportIsNotValid";
import Validated from "./controls/Validated";
import { WaitingForValidation } from "./controls/WaitingForValidation";
import type { SelectedCompany, SelectedCompanyReport } from "./hooks/SelectedCompany";
import type { ReportValidationType } from "./hooks/useReportValidation";

interface Props {
  company: SelectedCompany;
  report: SelectedCompanyReport;
  activeCompany: SelectedCompany | undefined;
  availableCompanies: ListItemData[];
  validation: ReportValidationType;
  onSelectedCompanyReport: (companyReport: SelectedCompanyReport | undefined) => void;
}

export function CompanySingleReportListItemContainer({
  activeCompany,
  company,
  report,
  availableCompanies,
  validation,
  onSelectedCompanyReport,
}: Props) {
  return (
    <CompanySingleReportListItem
      key={company.code}
      company={company}
      selectable
      inProgress={report.validating}
      active={activeCompany?.code === company.code}
      companyBranding={availableCompanies.find((c) => c.value === company.code)}
      Action={
        <CloseIconButton
          onClick={() => validation.removeCompany(company.code)}
          color="secondary"
          iconProps={{ sx: (theme) => ({ color: theme.palette.secondary.light }) }}
        />
      }
      onSelected={() => onSelectedCompanyReport(report)}
    >
      {!report.validating && !report.validated && !report.error && <WaitingForValidation />}
      {report.validating && (
        <ReportInProgress text="Please wait while we check if the report can be copied within the company..." />
      )}
      {report.validated && report.result?.hasRequiredDataset === false && (
        <ReportIsNotValid
          errorMessage={`Dataset ${report.result?.requiredDataSetName ?? ""} is missing in the target company.`}
        />
      )}
      {report.validated && report.result?.hasRequiredDataset && <Validated companyReport={report} />}
      {report.error && <Failed onRetry={() => validation.retryValidation(report)} />}
    </CompanySingleReportListItem>
  );
}
